import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "time-delivery",
  "use": "time-delivery-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"time-delivery\"><path d=\"M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2ZM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Zm.5-12.25a.75.75 0 0 0-1.5 0v4.684a1 1 0 0 0 .486.857l4.152 2.492a.719.719 0 1 0 .737-1.234L12.5 12.25v-4.5Z\" fill=\"#003595\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol